import * as React from "react";
import { pink, grey, purple, lightBlue, red } from "@mui/material/colors";
import Radio from "@mui/material/Radio";

const ThemeRadioButtons = ({ theme, changeTheme }) => {
  const handleChange = (event) => {
    changeTheme(event.target.value);
  };

  const controlProps = (item) => ({
    checked: theme === item,
    onChange: handleChange,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": item },
  });
  return (
    <>
      <Radio
        {...controlProps("Blue")}
        sx={{
          padding: "0 !important",
          color: lightBlue[800],
          "&.Mui-checked": {
            color: lightBlue[600],
          },
        }}
      />
      <Radio
        {...controlProps("Gradient")}
        sx={{
          padding: "0 !important",
          color: "#d500f9",
          "&.Mui-checked": {
            color: "#d500f9",
          },
        }}
        color="secondary"
      />
      <Radio
        {...controlProps("Dark")}
        sx={{
          padding: "0 !important",
          color: grey[800],
          "&.Mui-checked": {
            color: grey[600],
          },
        }}
        color="success"
      />
      <Radio
        {...controlProps("White")}
        sx={{
          padding: "0 !important",
          color: "#ffa4ff",
          "&.Mui-checked": {
            color: "#ffa4ff",
          },
        }}
        color="default"
      />
      <Radio
        {...controlProps("Pink")}
        sx={{
          padding: "0 !important",
          color: red[800],
          "&.Mui-checked": {
            color: red[600],
          },
        }}
      />
    </>
  );
};

export default ThemeRadioButtons;
